import { SubmitHandler, useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import RhfMultiCheckbox from '../ui/forms/RhfMultiCheckbox';
import CustomForm, { onSuccessCallback } from '../ui/forms/CustomForm';
import useFormSubmitErrorAlert from '../ui/forms/useFormSubmitErrorAlert';
import { CustomersExportReportDto } from '../../lib/api/reports/dto/customers-export-report.dto';
import { Grid } from '@mui/material';
import FromSubmitButton from '../ui/forms/FormSubmitButton';
import { downloadCustomersExport } from '../../lib/common/report-download.service';

interface Props {
  onSuccess?: onSuccessCallback;
}

export default function DownloadCustomersFormForm({ onSuccess }: Props) {
  const {
    handleSubmit,
    formState: { isSubmitting, isValid, isSubmitted },
    setError,
    control,
  } = useForm<CustomersExportReportDto>({
    resolver: classValidatorResolver(CustomersExportReportDto),
    defaultValues: {
      include: [],
    },
    mode: 'onTouched',
  });

  const { clearFormSubmitError, processFormSubmitError, serverErrorMessage } =
    useFormSubmitErrorAlert<CustomersExportReportDto>();

  const onSubmit: SubmitHandler<CustomersExportReportDto> = async (
    formData: CustomersExportReportDto,
  ) => {
    clearFormSubmitError();

    try {
      await downloadCustomersExport(formData);

      onSuccess?.();
    } catch (err: any) {
      console.log('err', err);
      processFormSubmitError(err, setError);
    }
  };

  const includeOptions = [
    { value: 'addresses', label: 'Addresses' },
    { value: 'contacts', label: 'Contacts' },
  ];

  return (
    <CustomForm
      serverErrorMessage={serverErrorMessage}
      handleSubmit={handleSubmit(onSubmit)}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RhfMultiCheckbox
            name="include"
            label="Select Relations to include"
            options={includeOptions}
            control={control}
            required={false}
            row={false} // Display horizontally
          />
        </Grid>
        <Grid item xs={12}>
          <FromSubmitButton
            isSubmitted={isSubmitted}
            isSubmitting={isSubmitting}
            isValid={isValid}
            text={`Download Customers`}
          />
        </Grid>
      </Grid>
    </CustomForm>
  );
}
